Vue.component('goal-breakdown-chart', {

    // Using https://github.com/chartjs/chartjs-plugin-annotation for annotations

  props: ['goal', 'breakdown'],

  template: `
    <div class="graph-container goal-graph-container" :style="chartStyle">
        <canvas v-show="readyToShowChart" class="goal-breakdown-chart"></canvas>
    </div>
  `,

  computed: {
    chartWidth() {

        let width = this.breakdown ? this.breakdown.length * 40 : 0

        if (width < 400) width = 400

        return width
    },
    readyToShowChart() {
        return this.breakdown
    },
    chartStyle() {
        return 'width:' + this.chartWidth + 'px; height: 300px;'
    },
  },

  data() {
    return {
      chart: null,
      successColor: '#91e084',
      baseColor: 'rgba(0, 174, 241, 0.5)',
      failedColor: '#ff8068',
      activeBorder: '#666666',
      futureBorder: '#e4e4e4',
      actualReviewCountBar: {
        label: 'Number of reviews',
        type: 'bar',
        data: [],
        backgroundColor: [],
        borderColor: 'rgb(0, 174, 241)',
        borderWidth: 1,
        yAxisID: 'y-axis-1',
        borderSkipped: 'top',
      },
      actualAverageRatingLine: {
        label: 'Rating',
        type: 'line',
        data: [],
        pointBackgroundColor: [],
        pointBorderColor: '#2CC3FC',
        borderColor: '#00aef1',
        pointRadius: 4,
        pointBorderWidth: 0,
        borderWidth: 3,
        fill: false,
        lineTension: 0,
        yAxisID: 'y-axis-2'
      },
      goalAverageRatingLine: {
        label: 'Expected Rating',
        type: 'line',
        data: [],
        borderColor: '#e4e4e4',
        borderWidth: 2.5,
        borderDash: [3, 5],
        fill: false,
        lineTension: 0,
        yAxisID: 'y-axis-2'
      },
      goalReviewCountBar: {
        label: 'Expected # of reviews',
        type: 'bar',
        data: [],
        backgroundColor: '#ffffff',
        borderColor: [],
        borderDash: [2, 2],
        borderWidth: 1,
        yAxisID: 'y-axis-1'
      },
    }
  },

  watch: {
    breakdown: function(newValue, oldValue) {
        let instance = this

        Vue.nextTick(function() {
                instance.setupChart()
                instance.fillinChartData()
        })
    }
  },

  methods: {

    setDrawLineSettings(area) {
        let ctx = area.getContext("2d")
        var instance = this

        Chart.plugins.register ( {
            afterDatasetsDraw: function(chart) {

                chart_type = chart.config.type;
                
                if (chart.tooltip._active && chart.tooltip._active.length == 4) {

                    let pointA = chart.tooltip._active[0]
                    let pointB = chart.tooltip._active[1]
                    
                    let ctx = chart.chart.ctx,
                    x_axis = chart.scales['x-axis-1'],
                    y_axis = chart.scales['y-axis-1'],
                    x = pointA._view.x,
                    y = pointA._view.y,
                    bottomY = pointB._view.y

                    // draw line
                    ctx.save();
                    
                    // Create dotted line
                    ctx.beginPath()
                    ctx.moveTo(x, y)
                    ctx.lineTo(x, bottomY)
                    ctx.setLineDash([2,1])
                    ctx.lineWidth = 1

                    if (pointA._view.y > pointB._view.y) {
                        ctx.strokeStyle = this.successColor
                    } else if (pointA._view.y > pointB._view.y) {
                        ctx.strokeStyle = this.failedColor
                    } else {
                        ctx.strokeStyle = this.futureBorder
                    }

                    ctx.stroke()

                    ctx.restore()
                }
            }
        });
    },

    setupChart() {

      try {
        var area = document.getElementsByClassName('goal-breakdown-chart')[0]
      } catch (error) {
        return
      }
    if (this.chart) {
        //console.log('setupChart: this.chart.destroy')
        this.chart.destroy()
    }

      Chart.defaults.bar.scales.xAxes[0].categorySpacing = 0
      var isDrawn = false

      this.setDrawLineSettings(area)

      this.chart = new Chart(area, {
        type: 'bar',
        data: {
            labels: [],
            datasets: [
                this.actualAverageRatingLine,
                this.goalAverageRatingLine,
                this.actualReviewCountBar,
                this.goalReviewCountBar,
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: true,
                position: 'top'
            },
            scales : {
                yAxes : [
                    {
                        type: 'linear',
                        id: 'y-axis-1',
                        ticks : {
                            // stepSize: 1,
                            beginAtZero: true,
                            fontColor: '#2c2d49'
                        },
                        scaleLabel: {
                            display: false,
                            labelString: 'R E V I E W S',
                            fontColor: '#2c2d49'
                        },
                        gridLines: {
                            color: "#fff"
                        },
                    },
                    {
                        ticks: {
                            max: this.goal.base_data.source_rating_type + 1,
                            beginAtZero: true,
                            fontColor: '#2c2d49',
                            stepSize: 1
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'R A T I N G S',
                            fontColor: '#2c2d49'
                        },
                        position: 'right',
                        type: 'linear',
                        id: 'y-axis-2',
                        gridLines: {
                            display: false,
                            color: "#f2f2f2"
                        }
                    },
                ],
                xAxes : [
                    {
                        display: false,
                        scaleLabel: {
                            display: true,
                            labelString: 'T I M E'
                        },
                        gridLines: {
                            display: false
                        },
                        stacked: true,
                    },
                    {
                        gridLines: {
                            display: false
                        }
                    }
                ]
            },
            tooltips: {
                // Disable the on-canvas tooltip
                enabled: true,
                intersect: true,
                mode: 'label',
            },
            animation: {
                onComplete: function() {
                    if (! isDrawn ) {
                        isDrawn = true
                        $('.goal-chart-container').scrollLeft(16000)
                    }
                }
            },
            annotation: {
                events: ["click"],
                annotations: [
                /*
                    {
                    drawTime: "afterDatasetsDraw",
                    id: "hline",
                    type: "line",
                    mode: "horizontal",
                    scaleID: "y-axis-1",
                    value: 3,
                    borderColor: "black",
                    borderWidth: 5,
                    label: {
                    backgroundColor: "red",
                    content: "Test Label",
                    enabled: true
                    },
                    onClick: function(e) {
                    // The annotation is is bound to the `this` variable
                    console.log("Annotation", e.type, this);
                    }
                },
                */
            ]
            }
        }
        })

      this.chart.update()
    },

    fillinChartData() {

        this.chart.data.labels = []

        this.chart.data.datasets[0].data = []
        this.chart.data.datasets[1].data = []
        this.chart.data.datasets[2].data = []
        this.chart.data.datasets[3].data = []

        this.chart.data.datasets[0].pointBackgroundColor = []
        this.chart.data.datasets[2].backgroundColor = []
        this.chart.data.datasets[3].borderColor = []
        this.chart.options.annotation.annotations = []

        var prevPeriodLabel = null

        for (i in this.breakdown) {
            period = this.breakdown[i]
            this.chart.data.labels.push(period.period_label)
            this.chart.data.datasets[2].data.push(period.number_of_reviews)
            this.chart.data.datasets[0].data.push(period.average_rating / (100 / this.goal.base_data.source_rating_type))

            if (period.average_rating < this.goal.details.review_average) {
                this.chart.data.datasets[0].pointBackgroundColor.push("red")
            } else {
                this.chart.data.datasets[0].pointBackgroundColor.push("green")
            }

            if (period.time_status == 'before_goal') {
                this.chart.data.datasets[2].backgroundColor.push(this.futureBorder)
            } else if (period.number_of_reviews >= period.expectation) {
                this.chart.data.datasets[2].backgroundColor.push(this.successColor)
            } else if (period.number_of_reviews < period.expectation && period.time_status == 'past') {
                this.chart.data.datasets[2].backgroundColor.push(this.failedColor)
            } else {
                this.chart.data.datasets[2].backgroundColor.push(this.baseColor)
            }

            if (period.time_status == 'before_goal') {
                this.chart.data.datasets[1].data.push(null)
            } else {
                this.chart.data.datasets[1].data.push(this.goal.details.review_average_at_source_scale)
            }

            this.chart.data.datasets[3].data.push(period.expectation)

            if (period.time_status == 'future' || period.time_status == 'before_goal') {
                this.chart.data.datasets[3].borderColor.push(this.futureBorder)
            } else if (period.time_status == 'current') {
                this.chart.data.datasets[3].borderColor.push('#0028FF')
            } else {
                this.chart.data.datasets[3].borderColor.push(this.activeBorder)
            }

            if ( period.history && period.history.status ) {
                this.chart.options.annotation.annotations.push( this.targetAnnotation(period.history, period.period_label, prevPeriodLabel) )
            }

            prevPeriodLabel = period.period_label
        }

        this.chart.update()
    },

    statusToValue(statusString) {
        var val = this.goal.base_data.source_rating_type + 1    // place high-up on the y-axis
        switch ( statusString ) {
            case 'achieved':        return [ val, 'blue' ]; 
            case 'on_target':       return [ val, 'rgba(41, 169, 7, 0.5)' ];
            case 'off_target':      return [ val, 'rgba(245, 232, 192, 0.5)' ];
            case 'way_off_target':  return [ val, 'rgba(255, 203, 41, 0.5)' ];
            case 'failed':          return [ val, 'rgba(205, 53, 55, 0.5)' ];
            case 'cancelled':       return [ val, 'purple' ];
            default:                return [ val, 'white' ];
        }
      },

      targetAnnotation(history, periodLabel, prevPeriodLabel) {
          //console.log('targetAnnotation ' + periodLabel + ' ' + prevPeriodLabel)

          var displayData = this.statusToValue(history.status)    // array: 0 is the value, 1 is the color

          return {
            drawTime: "beforeDatasetsDraw",
            type: "box",
            xScaleID: "x-axis-1",
            yScaleID: "y-axis-2",
            xMin: prevPeriodLabel, // periodLabel,
            xMax: periodLabel, //'19 Nov-25 Nov', //periodLabel,
            yMin: displayData[0]-0.5,
            yMax: displayData[0],
            backgroundColor: displayData[1], // "rgba(101, 33, 171, 0.5)",
            borderColor: displayData[1], 
            borderWidth: 2,
            onClick: function(e) {
                //console.log("Box clicked", history, e.type, this)
                var extraData = history.extra_data
                var status = history.status.replace(/_/g," ")
                var dataAsHtml = history.date.substring(0, 10) + '<small> (' + extraData.time.up_to_now_days + ' days out of ' + extraData.time.all_days + ', ' +
                    extraData.time.remaining_days + ' days remaining. ' + Math.round(history.progress_in_time * 100) / 100 + '% completed) </small>' +
                    '<br>' + '<strong>' + status.charAt(0).toUpperCase() + status.slice(1) + '</strong>' +
                    '<br>' + history.message.substring(15) + 
                    '<br>'

                $("#goalBreakdownTargetModal .modal-body").html(dataAsHtml)
                $('#goalBreakdownTargetModal').modal('show');
            }
          }
      }

  },

  mounted() {
  }

})